import { supabase } from '@/integrations/supabase/client';

/**
 * Test the Supabase connection
 * This function attempts to connect to Supabase and returns connection status
 */
export async function testSupabaseConnection() {
  try {
    // Try to get the current session (this will test the connection)
    const { data, error } = await supabase.auth.getSession();
    
    if (error) {
      console.error('Supabase connection error:', error);
      return { success: false, error: error.message };
    }
    
    console.log('Supabase connection successful!');
    return { success: true, session: data.session };
  } catch (error) {
    console.error('Supabase connection failed:', error);
    return { success: false, error: error instanceof Error ? error.message : 'Unknown error' };
  }
}

/**
 * Test database access by trying to query the products table
 */
export async function testDatabaseAccess() {
  try {
    // Try to query the products table
    const { data, error } = await supabase
      .from('products')
      .select('id, slug, name, group')
      .limit(5);

    if (error) {
      console.error('Database access error:', error);
      return { success: false, error: error.message };
    }

    console.log('Database access successful!', data);
    return { success: true, data };
  } catch (error) {
    console.error('Database access failed:', error);
    return { success: false, error: error instanceof Error ? error.message : 'Unknown error' };
  }
}

/**
 * Test querying questions for a specific product
 */
export async function testQuestionsQuery() {
  try {
    // Get questions for Property All Risks
    const { data, error } = await supabase
      .from('questions')
      .select(`
        id,
        key,
        label,
        type,
        required,
        options_json,
        sort_order,
        products!inner(slug, name)
      `)
      .eq('products.slug', 'property_all_risks')
      .order('sort_order');

    if (error) {
      console.error('Questions query error:', error);
      return { success: false, error: error.message };
    }

    console.log('Questions query successful!', data);
    return { success: true, data };
  } catch (error) {
    console.error('Questions query failed:', error);
    return { success: false, error: error instanceof Error ? error.message : 'Unknown error' };
  }
}
